import './NavRail.css'

// ---- Icons (lightweight inline SVGs, stroke = currentColor) ----
const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

export const IconChevronLeft = () => (
  <svg {...svgProps}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
)

export const IconChevronRight = () => (
  <svg {...svgProps}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
)

export const IconPlus = () => (
  <svg {...svgProps}>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
)

// A framed window with a plus - "add a window to the grid" (distinct from the
// plain plus, which creates a new searchroom entity).
export const IconAddWindow = () => (
  <svg {...svgProps}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <line x1="12" y1="10" x2="12" y2="16" />
    <line x1="9" y1="13" x2="15" y2="13" />
  </svg>
)

export const IconSearch = () => (
  <svg {...svgProps}>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
)

export const IconFilter = () => (
  <svg {...svgProps} className="nav-rail-filter">
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
)

// A bookmark tag with a plus - "bookmark a new item".
export const IconBookmarkPlus = () => (
  <svg {...svgProps}>
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h7" />
    <line x1="17" y1="3" x2="17" y2="9" />
    <line x1="14" y1="6" x2="20" y2="6" />
  </svg>
)

// A folder with a plus - "create a new topic".
export const IconFolderPlus = () => (
  <svg {...svgProps}>
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    <line x1="12" y1="11" x2="12" y2="17" />
    <line x1="9" y1="14" x2="15" y2="14" />
  </svg>
)

// A folder with a pencil - "manage / edit topics".
export const IconFolderEdit = () => (
  <svg {...svgProps}>
    <path d="M11 21H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2v3" />
    <path d="M18.5 13.5a1.7 1.7 0 0 1 2.4 2.4L16 21l-3 .5.5-3z" />
  </svg>
)

export const IconBell = () => (
  <svg {...svgProps}>
    <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
)

// Single icon button used throughout the rail.
export function RailButton({ label, onClick, active, dot, children }) {
  const className =
    'nav-rail-btn' +
    (active ? ' is-active' : '') +
    (dot ? ' nav-rail-dot' : '')
  return (
    <button
      type="button"
      className={className}
      title={label}
      aria-label={label}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

// Thin vertical action column inside MainNav. Built-in collapse toggle up top,
// page-provided `actions` (e.g. "new searchroom") below it, and an optional
// `footer` node pinned to the bottom (e.g. notifications).
function NavRail({ collapsed, onToggleCollapse, actions = [], footer }) {
  return (
    <div className="nav-rail">
      <div className="nav-rail-top">
        <RailButton
          label={collapsed ? 'Expand nav' : 'Collapse nav'}
          onClick={onToggleCollapse}
        >
          {collapsed ? <IconChevronRight /> : <IconChevronLeft />}
        </RailButton>

        {actions.map((action) => (
          <RailButton
            key={action.key}
            label={action.label}
            onClick={action.onClick}
            active={action.active}
            dot={action.dot}
          >
            {action.icon}
          </RailButton>
        ))}
      </div>

      {footer != null && <div className="nav-rail-footer">{footer}</div>}
    </div>
  )
}

export default NavRail
